(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    /* Registered once globally; guarded so bundling can't double-define. */
  if (!customElements.get('size-guide-modal')) {
    customElements.define('size-guide-modal', class SizeGuideModal extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.size-guide__trigger');
        this.dialog = this.querySelector('dialog');
        if (!this.trigger || !this.dialog || this._wired) return;
        this._wired = true;

        this.trigger.addEventListener('click', () => this.open());

        this.querySelectorAll('[data-sg-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        /* Click on the backdrop (target is the dialog element itself) closes it. */
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });

        /* ESC fires the native 'cancel' event; intercept so we can animate out. */
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();               /* top-layer + focus trap + inert bg */
        document.body.classList.add('size-guide-open');
      }

      close() {
        const finish = () => {
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
          document.body.classList.remove('size-guide-open');
          this.dialog.removeEventListener('animationend', finish);
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finish();
        } else {
          this.dialog.classList.add('is-closing');
          this.dialog.addEventListener('animationend', finish, { once: true });
        }
      }
    });
  }

  /* Scroll lock helper (added once). */
  if (!document.getElementById('size-guide-lock-style')) {
    const s = document.createElement('style');
    s.id = 'size-guide-lock-style';
    s.textContent = 'body.size-guide-open{overflow:hidden;}';
    document.head.appendChild(s);
  }
  } catch(e) { console.error(e); }
})();

})();
